import React from "react";
import { Outlet, Navigate, Link, useLocation } from "react-router-dom";
import { usePartnerAuth } from "../lib/partnerAuth";
import { Loader2, GraduationCap, LogOut, Home } from "lucide-react";
import { Button } from "../components/ui/button";

export default function PartnerLayout() {
  const { partner, loading, logout } = usePartnerAuth();
  const location = useLocation();
  if (loading) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-500" /></div>;
  if (!partner) return <Navigate to="/partner/login" replace state={{ from: location }} />;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/partner" className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-orange-500 flex items-center justify-center text-white"><GraduationCap className="w-5 h-5" /></div>
            <div>
              <div className="heading-font text-lg font-bold text-slate-900 leading-none">Admissio<span className="text-orange-500">.</span></div>
              <div className="text-xs text-slate-500 mt-0.5">Partner Portal</div>
            </div>
          </Link>
          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium text-slate-900" data-testid="partner-company-name">{partner.company_name}</div>
              <div className="text-xs text-slate-500">{partner.contact_person}</div>
            </div>
            <Button data-testid="partner-logout-btn" variant="outline" size="sm" onClick={logout}><LogOut className="w-4 h-4 mr-1" />Sign out</Button>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-8">
        <Outlet />
      </main>
    </div>
  );
}
